'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import http from 'hub-http/clients/noPortalApiClient';
import isValidURL from '../utils/urlValidator';
import { parse } from 'hub-http/helpers/params';
export default function StagingAuthRedirection(props) {
  useEffect(() => {
    const parsedQuery = parse(props.location.search);
    const referer = parsedQuery.referer || parsedQuery['?referer'];
    http.get('https://api.hubspot.com/khoros/integration/auth/staging/token').then(token => {
      document.cookie = `lithiumSSO%3Amjmao93648=${token}; Path=/; Domain=.hubspot.com; Secure`;
      window.location = isValidURL(referer) ? referer : 'https://community-stage.hubspot.com';
    }).catch(error => {
      if (error.status === 400 && error.responseJSON.message.includes('impersonating')) {
        window.location = '/login-as-error';
      }
    });
  }, [props.location]);
  return /*#__PURE__*/_jsx(_Fragment, {});
}